import { Provider } from './Provider.js';

class HotjarProvider extends Provider {
  track(_properties) {
    this.logger.error('Hotjar track - Method not implemented');
  }
  setUserId(userId) {
    this.userId = userId;
    this.logger.log(`User id set with value ${userId}`);
  }
  setUserProperties(_ref) {
    let {
      properties
    } = _ref;
    if (this.scriptIsLoaded()) {
      if (!this.userId) {
        this.logger.error('Hotjar setUserProperties - Make sure you first call "setUserId" method');
        return;
      }
      const formattedProperties = properties.reduce((acc, property) => {
        acc[property.key] = property.value;
        return acc;
      }, {});
      window.hj('identify', this.userId, formattedProperties);
      this.logger.log(`The following properties have been save for userId ${this.userId}: ${JSON.stringify(formattedProperties)}`);
    }
  }
  scriptIsLoaded() {
    if (typeof document !== 'undefined') {
      const htmlScripts = Array.from(document.getElementsByTagName('script'));
      return !!htmlScripts.find(script => script.innerHTML.indexOf('https://static.hotjar.com/c/hotjar-') > 0) && window.hj;
    } else {
      return false;
    }
  }
  init(key) {
    const hotjarVersion = 6;
    if (!this.scriptIsLoaded() && typeof document !== 'undefined') {
      const pixel = document.createElement('script');
      pixel.type = 'text/javascript';
      const scriptContent = `
                (function(h,o,t,j,a,r){
                    h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
                    h._hjSettings={hjid:${key},hjsv:${hotjarVersion}};
                    a=o.getElementsByTagName('head')[0];
                    r=o.createElement('script');r.async=1;
                    r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                    a.appendChild(r);
                })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
            `;
      pixel.innerHTML = scriptContent;
      document.getElementsByTagName('head')[0].appendChild(pixel);
      this.logger.log(`Hotjar script appended to <head> with Key: ${key}`);
    }
  }
}

export { HotjarProvider };
//# sourceMappingURL=HotjarProvider.js.map
